/* Asuno countdown timer — starts on page load, resets per session. */
(function () {
    function startCountdown(el) {
        var total = parseInt(el.getAttribute('data-minutes') || '10', 10) * 60
            + parseInt(el.getAttribute('data-seconds') || '15', 10);
        var storageKey = 'asuno_countdown_' + (el.getAttribute('data-key') || 'default');
        var endAt;

        try {
            var saved = sessionStorage.getItem(storageKey);
            if (saved) {
                endAt = parseInt(saved, 10);
                if (isNaN(endAt) || endAt < Date.now()) {
                    endAt = Date.now() + total * 1000;
                    sessionStorage.setItem(storageKey, endAt);
                }
            } else {
                endAt = Date.now() + total * 1000;
                sessionStorage.setItem(storageKey, endAt);
            }
        } catch (e) {
            endAt = Date.now() + total * 1000;
        }

        function pad(n) { return n < 10 ? '0' + n : '' + n; }

        function tick() {
            var remaining = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
            var m = Math.floor(remaining / 60);
            var s = remaining % 60;
            el.textContent = pad(m) + ':' + pad(s);
            if (remaining <= 0) {
                clearInterval(interval);
            }
        }

        tick();
        var interval = setInterval(tick, 1000);
    }

    function init() {
        var nodes = document.querySelectorAll('[data-asuno-countdown]');
        for (var i = 0; i < nodes.length; i++) startCountdown(nodes[i]);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
